/* tslint:disable */
/* eslint-disable */
/**
 * Universal Process API
 * Universal Process App API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ChatConversationDto } from '../models';
// @ts-ignore
import type { ChatConversationWithUnreadInfoDto } from '../models';
// @ts-ignore
import type { ChatMessageCreationRequestDto } from '../models';
// @ts-ignore
import type { ChatMessageCreationResponseDto } from '../models';
// @ts-ignore
import type { ChatMessagesPageableResponseDto } from '../models';
// @ts-ignore
import type { ChatMessagesSearchRequestDto } from '../models';
// @ts-ignore
import type { ChatReadStatusUpdateRequestDto } from '../models';
/**
 * RestChatApi - axios parameter creator
 */
export const RestChatApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create new chat message
         * @param {number} chatId 
         * @param {ChatMessageCreationRequestDto} chatMessageCreationRequestDto Create chat message
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createChatMessage: async (chatId: number, chatMessageCreationRequestDto: ChatMessageCreationRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'chatId' is not null or undefined
            assertParamExists('createChatMessage', 'chatId', chatId)
            // verify required parameter 'chatMessageCreationRequestDto' is not null or undefined
            assertParamExists('createChatMessage', 'chatMessageCreationRequestDto', chatMessageCreationRequestDto)
            const localVarPath = `/api/chats/{chatId}/messages`
                .replace('{chatId}', encodeURIComponent(String(chatId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(chatMessageCreationRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Read chat conversations
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readChatConversations: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('readChatConversations', 'userId', userId)
            const localVarPath = `/api/chats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List chat conversations with unread info
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readChatConversationsStatus: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('readChatConversationsStatus', 'userId', userId)
            const localVarPath = `/api/chats/status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Search chat messages
         * @param {number} chatId 
         * @param {number} page 
         * @param {number} pageSize 
         * @param {ChatMessagesSearchRequestDto} chatMessagesSearchRequestDto Chat messages search request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchChatMessages: async (chatId: number, page: number, pageSize: number, chatMessagesSearchRequestDto: ChatMessagesSearchRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'chatId' is not null or undefined
            assertParamExists('searchChatMessages', 'chatId', chatId)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('searchChatMessages', 'page', page)
            // verify required parameter 'pageSize' is not null or undefined
            assertParamExists('searchChatMessages', 'pageSize', pageSize)
            // verify required parameter 'chatMessagesSearchRequestDto' is not null or undefined
            assertParamExists('searchChatMessages', 'chatMessagesSearchRequestDto', chatMessagesSearchRequestDto)
            const localVarPath = `/api/chats/{chatId}/messages/search`
                .replace('{chatId}', encodeURIComponent(String(chatId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(chatMessagesSearchRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update chat conversation read time
         * @param {number} chatId 
         * @param {string} userId 
         * @param {ChatReadStatusUpdateRequestDto} chatReadStatusUpdateRequestDto Update last read timestamp for a chat conversation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateChatReadTime: async (chatId: number, userId: string, chatReadStatusUpdateRequestDto: ChatReadStatusUpdateRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'chatId' is not null or undefined
            assertParamExists('updateChatReadTime', 'chatId', chatId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateChatReadTime', 'userId', userId)
            // verify required parameter 'chatReadStatusUpdateRequestDto' is not null or undefined
            assertParamExists('updateChatReadTime', 'chatReadStatusUpdateRequestDto', chatReadStatusUpdateRequestDto)
            const localVarPath = `/api/chats/{chatId}/mark-as-read`
                .replace('{chatId}', encodeURIComponent(String(chatId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(chatReadStatusUpdateRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RestChatApi - functional programming interface
 */
export const RestChatApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RestChatApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create new chat message
         * @param {number} chatId 
         * @param {ChatMessageCreationRequestDto} chatMessageCreationRequestDto Create chat message
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createChatMessage(chatId: number, chatMessageCreationRequestDto: ChatMessageCreationRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatMessageCreationResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createChatMessage(chatId, chatMessageCreationRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestChatApi.createChatMessage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Read chat conversations
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async readChatConversations(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ChatConversationDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.readChatConversations(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestChatApi.readChatConversations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List chat conversations with unread info
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async readChatConversationsStatus(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ChatConversationWithUnreadInfoDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.readChatConversationsStatus(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestChatApi.readChatConversationsStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Search chat messages
         * @param {number} chatId 
         * @param {number} page 
         * @param {number} pageSize 
         * @param {ChatMessagesSearchRequestDto} chatMessagesSearchRequestDto Chat messages search request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchChatMessages(chatId: number, page: number, pageSize: number, chatMessagesSearchRequestDto: ChatMessagesSearchRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatMessagesPageableResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchChatMessages(chatId, page, pageSize, chatMessagesSearchRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestChatApi.searchChatMessages']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update chat conversation read time
         * @param {number} chatId 
         * @param {string} userId 
         * @param {ChatReadStatusUpdateRequestDto} chatReadStatusUpdateRequestDto Update last read timestamp for a chat conversation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateChatReadTime(chatId: number, userId: string, chatReadStatusUpdateRequestDto: ChatReadStatusUpdateRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateChatReadTime(chatId, userId, chatReadStatusUpdateRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestChatApi.updateChatReadTime']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RestChatApi - factory interface
 */
export const RestChatApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RestChatApiFp(configuration)
    return {
        /**
         * 
         * @summary Create new chat message
         * @param {number} chatId 
         * @param {ChatMessageCreationRequestDto} chatMessageCreationRequestDto Create chat message
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createChatMessage(chatId: number, chatMessageCreationRequestDto: ChatMessageCreationRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<ChatMessageCreationResponseDto> {
            return localVarFp.createChatMessage(chatId, chatMessageCreationRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Read chat conversations
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readChatConversations(userId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<ChatConversationDto>> {
            return localVarFp.readChatConversations(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List chat conversations with unread info
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readChatConversationsStatus(userId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<ChatConversationWithUnreadInfoDto>> {
            return localVarFp.readChatConversationsStatus(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Search chat messages
         * @param {number} chatId 
         * @param {number} page 
         * @param {number} pageSize 
         * @param {ChatMessagesSearchRequestDto} chatMessagesSearchRequestDto Chat messages search request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchChatMessages(chatId: number, page: number, pageSize: number, chatMessagesSearchRequestDto: ChatMessagesSearchRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<ChatMessagesPageableResponseDto> {
            return localVarFp.searchChatMessages(chatId, page, pageSize, chatMessagesSearchRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update chat conversation read time
         * @param {number} chatId 
         * @param {string} userId 
         * @param {ChatReadStatusUpdateRequestDto} chatReadStatusUpdateRequestDto Update last read timestamp for a chat conversation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateChatReadTime(chatId: number, userId: string, chatReadStatusUpdateRequestDto: ChatReadStatusUpdateRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateChatReadTime(chatId, userId, chatReadStatusUpdateRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RestChatApi - interface
 */
export interface RestChatApiInterface {
    /**
     * 
     * @summary Create new chat message
     * @param {number} chatId 
     * @param {ChatMessageCreationRequestDto} chatMessageCreationRequestDto Create chat message
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createChatMessage(chatId: number, chatMessageCreationRequestDto: ChatMessageCreationRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<ChatMessageCreationResponseDto>;

    /**
     * 
     * @summary Read chat conversations
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    readChatConversations(userId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<ChatConversationDto>>;

    /**
     * 
     * @summary List chat conversations with unread info
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    readChatConversationsStatus(userId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<ChatConversationWithUnreadInfoDto>>;

    /**
     * 
     * @summary Search chat messages
     * @param {number} chatId 
     * @param {number} page 
     * @param {number} pageSize 
     * @param {ChatMessagesSearchRequestDto} chatMessagesSearchRequestDto Chat messages search request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchChatMessages(chatId: number, page: number, pageSize: number, chatMessagesSearchRequestDto: ChatMessagesSearchRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<ChatMessagesPageableResponseDto>;

    /**
     * 
     * @summary Update chat conversation read time
     * @param {number} chatId 
     * @param {string} userId 
     * @param {ChatReadStatusUpdateRequestDto} chatReadStatusUpdateRequestDto Update last read timestamp for a chat conversation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateChatReadTime(chatId: number, userId: string, chatReadStatusUpdateRequestDto: ChatReadStatusUpdateRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * RestChatApi - object-oriented interface
 */
export class RestChatApi extends BaseAPI implements RestChatApiInterface {
    /**
     * 
     * @summary Create new chat message
     * @param {number} chatId 
     * @param {ChatMessageCreationRequestDto} chatMessageCreationRequestDto Create chat message
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createChatMessage(chatId: number, chatMessageCreationRequestDto: ChatMessageCreationRequestDto, options?: RawAxiosRequestConfig) {
        return RestChatApiFp(this.configuration).createChatMessage(chatId, chatMessageCreationRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Read chat conversations
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public readChatConversations(userId: string, options?: RawAxiosRequestConfig) {
        return RestChatApiFp(this.configuration).readChatConversations(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List chat conversations with unread info
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public readChatConversationsStatus(userId: string, options?: RawAxiosRequestConfig) {
        return RestChatApiFp(this.configuration).readChatConversationsStatus(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Search chat messages
     * @param {number} chatId 
     * @param {number} page 
     * @param {number} pageSize 
     * @param {ChatMessagesSearchRequestDto} chatMessagesSearchRequestDto Chat messages search request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public searchChatMessages(chatId: number, page: number, pageSize: number, chatMessagesSearchRequestDto: ChatMessagesSearchRequestDto, options?: RawAxiosRequestConfig) {
        return RestChatApiFp(this.configuration).searchChatMessages(chatId, page, pageSize, chatMessagesSearchRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update chat conversation read time
     * @param {number} chatId 
     * @param {string} userId 
     * @param {ChatReadStatusUpdateRequestDto} chatReadStatusUpdateRequestDto Update last read timestamp for a chat conversation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateChatReadTime(chatId: number, userId: string, chatReadStatusUpdateRequestDto: ChatReadStatusUpdateRequestDto, options?: RawAxiosRequestConfig) {
        return RestChatApiFp(this.configuration).updateChatReadTime(chatId, userId, chatReadStatusUpdateRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}

